import axios from "axios";

const envUrl = process.env.REACT_APP_BACKEND_URL;
const sameOrigin = () => {
  try {
    return new URL(envUrl).origin === window.location.origin;
  } catch {
    return false;
  }
};
const BACKEND_URL = typeof window !== "undefined" && !sameOrigin() ? window.location.origin : envUrl;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function fileUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/files/")) return `${BACKEND_URL}${path}`;
  return `${API}/files/${path}`;
}
